function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Svg, { G, Circle, Path } from 'react-native-svg';
const GreenTick = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement(G, {
    transform: "translate(-41 -245) translate(18 227) translate(24 19)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Circle, {
    fill: "#03906A",
    fillRule: "nonzero",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement(Circle, {
    stroke: "#03906A",
    cx: 14,
    cy: 14,
    r: 13.5
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M11.442 20.289L6.5 15.567 11.442 20.289 21.354 10.4 11.442 20.289 11.842 20.667 11.442 20.289 11.06 20.668z"
  })));
};
const GreenTickIcon = /*#__PURE__*/React.memo(GreenTick);
export { GreenTickIcon };
//# sourceMappingURL=index.js.map